import { randomString } from '@fry/lib/utils';
import { BoardCardType, BoardCardJSON } from '@fry/boards/lib';

export class BoardCard {

    public id: string;
    public boardId: string;

    public type: BoardCardType;

    public options: Record<string, any>;

    public get isConfigurable(): boolean {
        return !!this.type.editComponent;
    }

    public constructor(type: BoardCardType, options: Record<string, any>, id?: string, boardId?: string) {
        this.id = id || randomString();
        this.boardId = boardId || 'generic';
        this.type = type;
        this.options = options;
    }

    public toJSON(): BoardCardJSON {
        return { id: this.id, type: this.type.name, options: this.options };
    }
}